import { Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  onClose: () => void;
};

function DuplicateRefundModal({ onClose }: Props) {
  return (
    <Modal isOpen hasBackdrop>
      <Modal.Header>
        <Title>
          <Icon.WarningFilled size={28} fillColor='#FF2D55' />
          동일인에 대한 중복 등록이 확인되었습니다.
        </Title>
      </Modal.Header>
      <Content>
        <Message>추가 등록이 필요하신 경우 고객센터로 문의해주세요</Message>
        <ContactWrapper>
          <ContactIcon>
            <Icon.Cs size={24} fillColor='#FFFFFF' />
          </ContactIcon>
          <ContactLabel>고객 센터</ContactLabel>
          <ContactTel>02-6275-8011</ContactTel>
        </ContactWrapper>
      </Content>
      <Modal.Footer>
        <Modal.Button variant='ok' onClick={onClose}>
          확인
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  );
}

const Title = styled.h3`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 16px;
`;

const Content = styled.div`
  width: 436px;
`;

const Message = styled.p`
  color: #5f6165;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  margin-bottom: 16px;
`;

const ContactWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px 6px 6px;
  border-radius: 120px;
  background-color: #f5f6f7;
`;

const ContactIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #7ca7fa;
  border-radius: 100px;
  margin-right: 12px;
`;

const ContactLabel = styled.span`
  position: relative;
  color: #5f6165;
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  margin-right: 36px;
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: -18px;
    transform: translateY(-50%);
    width: 1px;
    height: 20px;
    background-color: #a7a7a7;
  }
`;

const ContactTel = styled.span`
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 600;
  line-height: 150%;
`;

export default DuplicateRefundModal;
